<template>
	<div>
      <v-container grid-list-xl assignPricelist>
        <v-flex xs12>
          <strong style="color: red !important;">NOTE:</strong> <strong>The pricelists flagged as default are linked to all users by default. If this user requires additonal or specific pricelists then flag ALL the pricelists they require below. This will then link these pricelists only and ignore the default pricelists.</strong>
        </v-flex>
        <br />
        <v-flex xs3>
          <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
        </v-flex>
        <v-data-table loading="true" :headers="headers" :items="objUserPricelists"  ref="sortableTable" :search="search" hide-actions disable-initial-sort class="elevation-1 linkTableMedium">
          <template slot="items" slot-scope="props">            
            <tr class="sortableRow" id="rows">
              <td width="10%" class="px-1" style="width: 10%">
                <v-btn style="cursor: move" icon class="sortHandle"><v-icon>drag_handle</v-icon></v-btn>
              </td>
              <td width="10%"><v-switch v-model="props.item.used"></v-switch></td>
              <td width="20%">{{ props.item.pl_name }}</td>
              <td width="10%">{{ fncIsDefault(props.item.pl_is_default) }}</td>
              <td width="10%" v-html="fncCheckStatus(props.item.pl_active)"></td>
              <td width="25%">{{ props.item.pl_description }}</td>
              <td width="15%">{{ props.item.pl_modified }}</td>
            </tr>
          </template>
        </v-data-table>
        <v-layout row wrap class="">
          <div class="pl-4 pr-1 pb-2 pt-4 buttonHolder" style="padding-top: 0px !important;">
            <div style="float: right;">
              <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
              <v-btn color="success" class="text-xs-right" @click.stop="fncEditPricelists()">Save</v-btn>
            </div>
          </div>
        </v-layout>
      </v-container>	
      </div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import Sortable from 'sortablejs';
    
	export default {
        name: 'UserNotifications',
        components: {},
		data () {
          return {	
            search: '',
            headers: [
              { text: '', value: '', width: '10%' },
              { text: 'Active', value: '', width: '10%' },
              { text: 'Name', value: 'pl_name', width: '20%' },
              { text: 'Default', value: 'pl_name', width: '10%' },
              { text: 'Status', value: 'pl_active', width: '10%' },
              { text: 'Description', value: 'pl_description', width: '25%' },
              { text: 'Last Modified', value: 'pl_modified', width: '15%' },
            ]	
			}
		},
		methods: {
      fncIsDefault(isDefault) {
        if( isDefault == '1' ) {
          return 'Yes';
        } else {
          return 'No';
        }
      },
            fncCheckStatus( status ) {
              if( status == 1 ) {
                return '<strong style="color:green !important;">ACTIVE</strong>';
              } else {
                return '<strong style="color:red !important;">INACTIVE</strong>';
              }
            },
            fncHideModal () {
                this.$store.commit('hideModal');
            },
            fncEditPricelists() {
              this.$store.dispatch({
                  type: 'fncEditPricelists',
                  userId: this.globalModalParams.userId
              })              
            },
            fncReorderPricelists({ oldIndex, newIndex }) {
              this.$store.dispatch({
                type: 'fncReorderPricelists',
                start: oldIndex,
                end: newIndex,
                userId: this.globalModalParams.userId
              });    
            }
		},
		computed: {
			...mapGetters([
                'objAuthorize',
                'globalModalParams',
				'objUserPricelists'
			])
        },
        mounted() {
          new Sortable(
            this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
            {
              draggable: '.sortableRow',
              handle: '.sortHandle',
              onUpdate: this.fncReorderPricelists
            }
          )
        }
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css';
</style>
